import { Link } from "react-router-dom";
import { allNews, allActors, formatViews } from "@/lib/content";

const TAGS = ["长夜将尽", "光年之外", "春山可望", "无声告白", "专访", "科幻", "年代", "职场", "海外发行"];

export default function Sidebar() {
  const hot = [...allNews].sort((a, b) => b.hot - a.hot).slice(0, 6);
  const actors = allActors.slice(0, 4);

  return (
    <aside className="flex flex-col gap-6">
      <div className="rounded-lg bg-primary-900 text-primary-50 p-5">
        <h3 className="font-heading text-lg font-bold text-background-50 mb-1">品牌速览</h3>
        <p className="text-xs text-primary-100/75 mb-4">筱田优影视品牌官方站</p>
        <div className="grid grid-cols-3 gap-2 text-center">
          <div>
            <p className="font-heading text-xl font-bold text-accent-400">{allNews.length}</p>
            <p className="text-[11px] text-primary-100/70 mt-1">资讯</p>
          </div>
          <div>
            <p className="font-heading text-xl font-bold text-accent-400">9</p>
            <p className="text-[11px] text-primary-100/70 mt-1">作品</p>
          </div>
          <div>
            <p className="font-heading text-xl font-bold text-accent-400">{allActors.length}</p>
            <p className="text-[11px] text-primary-100/70 mt-1">人物</p>
          </div>
        </div>
        <Link
          to="/about"
          className="mt-5 h-10 rounded-md bg-accent-500 text-background-50 text-sm font-medium flex items-center justify-center gap-2 hover:bg-accent-600 transition-colors whitespace-nowrap"
        >
          了解筱田优
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="rounded-lg bg-background-50 border border-background-200 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2 mb-4">
          <i className="ri-fire-line text-accent-500 text-lg" />
          热门资讯榜
        </h3>
        <ol className="flex flex-col gap-3">
          {hot.map((news, index) => (
            <li key={news.id}>
              <Link to={`/news/${news.id}`} className="group flex items-start gap-3">
                <span className="shrink-0 text-sm font-bold text-foreground-300 w-4">{index + 1}</span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-foreground-800 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                    {news.title}
                  </p>
                  <span className="text-xs text-foreground-400 mt-1 inline-flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {formatViews(news.views)}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg bg-background-50 border border-background-200 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2 mb-4">
          <i className="ri-price-tag-3-line text-secondary-500 text-lg" />
          热门标签
        </h3>
        <div className="flex flex-wrap gap-2">
          {TAGS.map((tag) => (
            <Link
              key={tag}
              to={`/news?q=${encodeURIComponent(tag)}`}
              className="px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-800 text-xs hover:bg-secondary-200 transition-colors"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg bg-background-50 border border-background-200 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2 mb-4">
          <i className="ri-user-star-line text-primary-500 text-lg" />
          主创阵容
        </h3>
        <div className="flex flex-col gap-3">
          {actors.map((actor) => (
            <Link key={actor.id} to={`/actors/${actor.id}`} className="group flex items-center gap-3">
              <div className="w-11 h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
                <img
                  src={actor.photo}
                  alt={`${actor.name}照片`}
                  title={`${actor.name} - 演员资料`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {actor.name}
                </p>
                <p className="text-xs text-foreground-400 line-clamp-1">{actor.role}</p>
              </div>
            </Link>
          ))}
        </div>
        <Link
          to="/actors"
          className="mt-4 text-xs text-primary-600 hover:text-primary-700 transition-colors inline-flex items-center gap-1"
        >
          全部人物
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </aside>
  );
}